import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
import { evaluateAccessibility } from "../../Utils/Authorization";
import logo from "assets/img/logo-white.svg";
import { useSelector, useDispatch } from "react-redux";
import { resetUserData } from "ReduxStore/Slices/userSlice";
import { resetCampaignData } from "ReduxStore/Slices/campaignSlice";
import { resetTemplateData } from "ReduxStore/Slices/templateSlice";
import { setMenu } from "ReduxStore/Slices/menuSlice";
import SidebarNavLink from "./SidebarNavLink";
import { useHistory } from "react-router-dom";
import $ from "jquery";
import { setUserFlow } from "ReduxStore/Slices/userSlice";
import { resetWorkflowState } from "ReduxStore/Slices/workflowSlice";
import { resetAllCampaignData } from "ReduxStore/Slices/allCampaignSlice";
import {
  resetAudieceFilters,
  audienceGetNewFilterData,
} from "ReduxStore/Slices/audienceSlice";

import { ReactComponent as I1 } from 'assets/sidebar/1.svg';
import { ReactComponent as I2 } from 'assets/sidebar/2.svg';
import { ReactComponent as I3 } from 'assets/sidebar/3.svg';
import { ReactComponent as I4 } from 'assets/sidebar/4.svg';
import { ReactComponent as I5 } from 'assets/sidebar/5.svg';
import { ReactComponent as I6 } from 'assets/sidebar/6.svg';
import { ReactComponent as I7 } from 'assets/sidebar/7.svg';
import { ReactComponent as I8 } from 'assets/sidebar/8.svg';
import { ReactComponent as LOG } from '../../Log.svg';

import './side.css'
export default function Sidebar(props) {
  const user = useSelector((state) => state.userSetter);
  const navigation_toggle = useRef();
  const sidebar_ref = useRef();
  const logoname_ref = useRef();
  const sidebarfooter_ref = useRef();

  const dispatch = useDispatch();
  const history = useHistory();
  const [logout_hover, setLogoutHover] = useState(false);
  const { role } = useSelector(state => state.userSetter)

  const {menu} = useSelector(state => state.menuSlice)

  const [sidetooltips, setsidetooltips] = useState ('')

  const dashboardMenuItems = [
    { name: "Dashboard", url: "/admin/dashboard", allow: true , selected:true},
  ];

  const accountsMenuItems = (role== 'publisher' || role == 'partner')? [  { name: "Prospects", url: "/admin/contact/list", allow: true, selected:true }] :[
    { name: "All Contacts", url: "/admin/contact/list", allow: true , selected:true},
    { name: "Add Contacts", url: "/admin/contact/add", allow: true },
    { name: "All Audience", url: "/admin/contact/audience/details", allow: true  },
    { name: "All Audience", url: "/admin/contact/details", allow: true , hide:true },

    { name: "Create Audience", url: "/admin/contact/audience/create", allow: true },
  ];

  const salesAccountMenu = [
    { name: "All Contacts", url: "/admin/accounts/list", allow: true , selected:true},
  ]
  const salesMenuItems = [
    { name: "Deals", url: "/admin/sales/deals", allow: true , selected:true},
    { name: "Tasks", url: "/admin/sales/tasks", allow: true },
    { name: "Meetings", url: "/admin/sales/meetings/calender", allow: true },

  ]

  const campaignMenuItems = [
    { name: "All Campaigns", url: "/admin/campaign/all", allow: true , selected:true },
    {
      name: "Create Campaign",
      url: "/admin/campaign/create",
      allow:
        user.role === "compliance" && user.companyLevelComplaiceFlag === true
          ? false
          : true,
    },
  ];

  const templateMenuItems = [
    {
      name: "All Templates",
      url: "/admin/templates/all_templates",
      allow: true, selected:true
    },
    { name: "Create Templates", url: "/admin/templates/info", allow: true },
    { name: "Content Library", url: "/admin/templates/content", allow: true },
    { name: "Assets", url: "/admin/templates/assets", allow: true },
  ];

  const workflowMenuItems = [
    { name: "All Workflow", url: "/admin/workflow/all_workflows", allow: true , selected:true },
    {
      name: "Create Workflow",
      url: "/admin/workflow/createAutomation",
      allow: true,
    },
    {name:"Workflow", url:"/admin/workflow/automationstudio/create", allow:true, hide:true},
  ];

  const eventsignalMenuItems = [
    {
      name: "All Trigger",
      url: "/admin/triggersAndEvents/allTrigers",
      allow: true, selected:true
    },
    {
      name: "All Events",
      url: "/admin/triggersAndEvents/allEvents",
      allow: true,
    },
    {
      name: "Create Trigger",
      url: "/admin/triggersAndEvents/createTrigger",
      allow: true,
    },
    {
      name: "Create Event",
      url: "/admin/triggersAndEvents/createEvent",
      allow: true,
    },
    {
      name: "UTM Builder",
      url: "/admin/triggersAndEvents/UtmlBuilder",
      allow: true,
    },
  ];

  const settings = role =='publisher'? [ { name: "General", url: "/admin/settings/configurations", allow: true , selected:true}, { name: "Users", url: "/admin/settings/users", allow: true }] :[
    { name: "General", url: "/admin/settings/configurations", allow: true , selected:true},
    { name: "Users", url: "/admin/settings/users", allow: true },
    { name: "Objects", url: "/admin/settings/objects", allow: true },
    { name: "Apps", url: "/admin/settings/all_apps", allow: true },
    { name: "Billing", url: "/admin/settings/payments", allow: true },

  ];


  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };






  const logoutHandler = (e) => {
    // 
    sessionStorage.removeItem("token");
    sessionStorage.setItem("keptLogged", "false");
    localStorage.removeItem("token");
    localStorage.setItem("keptLogged", "false");
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    dispatch(resetUserData());
    dispatch(resetCampaignData());
    dispatch(resetTemplateData());
    history.push("/login");
  };
  const scrollToBottom = (element) => {
    element.scrollTop = element.scrollHeight;
  }





  function selectMenuIntial(id){
    let selectMenu = document.getElementsByClassName('side-item-selected')
    if(selectMenu && selectMenu.length > 0 && selectMenu[0] ){

      selectMenu[0].classList.remove('side-item-selected')
    }
    let menu = document.getElementById(id)
    console.log("menuuuuuu",menu,id)
    menu.classList.add('side-item-selected')

    let menuItems = []

    let currentPath = window.location.pathname

    if (id === 'm1') {
      menuItems = dashboardMenuItems
    } else if (id === 'm2') {
      menuItems = accountsMenuItems
      dispatch(resetAudieceFilters());
      dispatch(audienceGetNewFilterData());
      console.log("MMMMMMMMMMWSSSSS","m2")
    } else if (id === 'm3') {
      menuItems = salesMenuItems
    } else if (id === 'm4') {
      menuItems = campaignMenuItems
      dispatch(resetCampaignData());
      dispatch(resetTemplateData());
      dispatch(setUserFlow("createCampaign"));
      dispatch(resetAllCampaignData());
    } else if (id === 'm5') {
      menuItems = templateMenuItems
      dispatch(resetTemplateData(role =='publisher'?'blogTab': null));
      dispatch(resetCampaignData());
      dispatch(setUserFlow("createTemplate"));
      dispatch(resetTemplateData());
    } else if (id === 'm6') {
      menuItems = workflowMenuItems
      // dispatch(resetWorkflowState());

    } else if (id === 'm7') {
      menuItems = eventsignalMenuItems
      sessionStorage.removeItem('on_edit_trigger');
      sessionStorage.removeItem('trigger_edit_');
    }
    else if (id === 'm8') {
      menuItems = settings
    }

    if (menuItems.find((item) => item.url === currentPath)) {
      menuItems.map((item) => item.selected = false)
      menuItems.find((item) => item.url === currentPath).selected = true
    }




    history.push(menuItems.find((item) => item.selected).url+window.location.search)

    dispatch(setMenu(menuItems))
  }

  function selectMenu(id){
    let selectMenu = document.getElementsByClassName('side-item-selected')
    if(selectMenu && selectMenu.length > 0 && selectMenu[0] ){

      selectMenu[0].classList.remove('side-item-selected')
    }
    let menu = document.getElementById(id)
    console.log("menuuuuuu",menu,id)
    menu.classList.add('side-item-selected')

    let menuItems = []

    if (id === 'm1') {
      menuItems = dashboardMenuItems
    } else if (id === 'm2') {
      menuItems = accountsMenuItems
      dispatch(resetAudieceFilters());
      dispatch(audienceGetNewFilterData());
    } else if (id === 'm3') {
      menuItems = salesMenuItems
    } else if (id === 'm4') {
      menuItems = campaignMenuItems
      dispatch(resetCampaignData());
      dispatch(resetTemplateData());
      dispatch(setUserFlow("createCampaign"));
      dispatch(resetAllCampaignData());
    } else if (id === 'm5') {
      menuItems = templateMenuItems
      dispatch(resetTemplateData(role =='publisher'?'blogTab': null));
      dispatch(resetTemplateData());
      dispatch(resetCampaignData());
      dispatch(setUserFlow("createTemplate"));
    } else if (id === 'm6') {
      menuItems = workflowMenuItems
      // dispatch(resetWorkflowState());

    } else if (id === 'm7') {
      menuItems = eventsignalMenuItems
      sessionStorage.removeItem('on_edit_trigger');
      sessionStorage.removeItem('trigger_edit_');
    }
    else if (id === 'm8') {
      menuItems = settings
    }



    history.push(menuItems[0].url)

    dispatch(setMenu(menuItems))
  }

  useEffect(() => {

    console.log("useefffffffffffff emenu",menu)

    if(menu && menu.length > 0){

      let currSelected = document.getElementsByClassName('side-item-selected')
      if(currSelected && currSelected.length > 0){
        currSelected[0].classList.remove('side-item-selected')
      }


      let currentPath = window.location.pathname

      if (currentPath .includes( '/admin/dashboard')) {
        selectMenuIntial('m1')
      }
      else if (currentPath .includes('/admin/contact')) {
        selectMenuIntial('m2')
      }
      else if (currentPath .includes('/admin/sale')) {
        selectMenuIntial('m3')
      }
      else if (currentPath .includes( '/admin/campaign')) {
        selectMenuIntial('m4')
      }
      else if (currentPath .includes( '/admin/templates')) {
        selectMenuIntial('m5')
      }
      else if (currentPath .includes( '/admin/workflow')) {
        selectMenuIntial('m6')
      }
      else if (currentPath.includes('/admin/triggersAndEvents')) {
        selectMenuIntial('m7')
      }
      else if (currentPath .includes( '/admin/settings')) {
        selectMenuIntial('m8')
      }
    

     
    }
   
  }, []);

  function showText (e){

    let div = e.target.id
    console.log("ENTER",div)

    // setsidetooltips(div)
    // console.log(e.target)

  }
  function hidetext(e){

    let div = e.target.id

    console.log("LEAVE",div)


      if(sidetooltips == div ){
        // setsidetooltips('')
      }

    // let div = e.target
    // console.log(e.target)

  }


  return (
    <div id='sidebar-new' >
      <div className="side-list" onMouseEnter={(e)=>{
        // let divs = document.getElementsByClassName('tooltip-side')
        // if(divs && divs.length > 0){
        //   for(let i = 0; i < divs.length; i++){
        //     divs[i].style.display = 'block'
        //   }


        // }
      }}
      
      onMouseLeave={(e)=>{
        // let divs = document.getElementsByClassName('tooltip-side')
        // if(divs && divs.length > 0){
        //   for(let i = 0; i < divs.length; i++){
        //     divs[i].style.display = 'none'
        //   }
        // setsidetooltips('')


        // }
      }
      }
      
      
      >

        {evaluateAccessibility(

                  "/admin/dashboard",

            <div style={{position:"relative"}} id ='m1_'  className="side-bar-tooltip-cont"  onMouseEnter={showText} onMouseLeave={hidetext} >
              <div className="tooltip-side" > Dashboard</div> 
            <div className="side-item side-item-selected" onClick={()=>selectMenu('m1')} id='m1'>
              <a href="#">
                <I8 />

                {/* <div className='side-tooltip'> Dashboard </div> */}
              </a>


            </div>
            </div>

        )}

        {evaluateAccessibility(
            
                    "/admin/contact",
                    <div style={{position:"relative"}} className="side-bar-tooltip-cont"  id ='m2_' onMouseEnter={showText} onMouseLeave={hidetext} >
                    <div className="tooltip-side"   > Contacts</div> 
                    <div className="side-item" onClick={()=>selectMenu('m2')} id='m2'>
                      <a href="#">
                        <I1 />
          

                      </a>
                    </div>
                    </div>

        )}

        {evaluateAccessibility(
                    "/admin/sale",
                    <div style={{position:"relative"}} className="side-bar-tooltip-cont"  id ='m3_' onMouseEnter={showText} onMouseLeave={hidetext} >
                    <div className="tooltip-side"   > Sales</div> 
                    <div className="side-item" onClick={()=>selectMenu('m3')} id='m3'>
                      <a href="#">
                        <I2 />
                      </a>
                    </div>
                    </div>
        )}

        {evaluateAccessibility(
                    "/admin/campaign",
                    <div style={{position:"relative"}} className="side-bar-tooltip-cont"  id ='m4_' onMouseEnter={showText} onMouseLeave={hidetext} >
                    <div className="tooltip-side"    > Campaigns</div> 
                    <div className="side-item" onClick={()=>selectMenu('m4')} id='m4'>
                      <a href="#">
                        <I3 />
                      </a>
                    </div>
                    </div>
        )}

        {evaluateAccessibility(
                    "/admin/templates",
                    <div style={{position:"relative"}} className="side-bar-tooltip-cont"  id ='m5_' onMouseEnter={showText} onMouseLeave={hidetext} >
                    <div className="tooltip-side"   > Templates</div> 
                    <div className="side-item" onClick={()=>selectMenu('m5')} id='m5'>
                      <a href="#">
                        <I4 />
                      </a>
                    </div>
                    </div>
        )}

        {evaluateAccessibility(

                    "/admin/workflow",
                    <div style={{position:"relative"}} className="side-bar-tooltip-cont"  id ='m6_' onMouseEnter={showText} onMouseLeave={hidetext} >
                    <div className="tooltip-side"   > Workflows</div> 
                    <div className="side-item" onClick={()=>selectMenu('m6')} id='m6'>
                      <a href="#">
                        <I5 />
                      </a>

                    </div>
                  </div>
        )}

        {evaluateAccessibility(
                    "/admin/triggersAndEvents",
                    <div style={{position:"relative"}} className="side-bar-tooltip-cont"  id ='m7_' onMouseEnter={showText} onMouseLeave={hidetext} >
                    <div className="tooltip-side"     > Signals</div> 
                    <div className="side-item" onClick={()=>selectMenu('m7')}id='m7'>
                      <a href="#">
                        <I6 />
                      </a>
                    </div>
                    </div>
        )}

        {evaluateAccessibility(
                    "/admin/settings",
                    <div style={{position:"relative"}}  className="side-bar-tooltip-cont"  id ='m8_' onMouseEnter={showText} onMouseLeave={hidetext} >
                    <div className="tooltip-side"  > Settings</div> 
                    <div className="side-item" onClick={()=>selectMenu('m8')} id='m8'>
                      <a href="#">
                        <I7 />
                      </a>
                    </div>
                  </div>
        )}

        <div className="side-item" onClick={logoutHandler}>
          <a href="#">
            <LOG style={{width:"20px", height:"20px"}} />
          </a>

      </div>






      </div>


    </div>















//     <div>
//       {" "}
//       <div className="sidebar-wrap">


//         <div className="sidebar-logo">
//           <a className="logo-link navbar-brand has_left_icon" href="#" tabIndex="-1">
//             <span className="">
//               <img src={logo} />
//             </span>{" "}
//             <span
//               className="logoname"
//               ref={logoname_ref}
//             >
//               Kapitalwise
//             </span>
//           </a>
//           <a
//             href="#"
//             className="navigation-toggle"
//             ref={navigation_toggle}
//             onClick={() => {
//               sidebar_ref.current.classList.toggle("active");
//               logoname_ref.current.classList.toggle("collapsed");
//               logoname_ref.current.classList.toggle("collapse-menu");
//               sidebarfooter_ref.current.classList.toggle("collapsed");
//               sidebarfooter_ref.current.classList.toggle("collapse-menu");

//               $(".main-panel").toggleClass("collapsed");
//               navigation_toggle.current.classList.toggle("collapse-menu");
//             }}
//           >


//             <span>
//               <i className="fas fa-chevron-left"></i>
//             </span>
//           </a>
//         </div>

//         <div
//           className="Sidebar"
//           ref={sidebar_ref}
//           data-color={props.backgroundColor}
//         >
//           {/* <!-- Navbar links --> */}
//           <Nav className="navbar navbar-expand-sm flex-column align-items-start">

//             <div className="collapse navbar-collapse" id="navbarsExample03">
//               <ul className="navbar-nav flex-column">
//                 {evaluateAccessibility(
//                   "/admin/dashboard",
//                   <SidebarNavLink
//                     menuName={"Dashboard"}
//                     menuURL={"/admin/dashboard"}
//                     menuItems={dashboardMenuItems}
//                     menuIcon={"fas fa-home"}
//                     activeRoute={activeRoute}
//                   ></SidebarNavLink>
//                 )}
//                 {evaluateAccessibility(
//                   "/admin/accounts",
//                   <SidebarNavLink
//                     menuName={role =='publisher'?"Prospects":"Contacts"}
//                     menuURL={"/admin/contact"}
//                     menuItems={accountsMenuItems}
//                     menuIcon={"now-ui-icons icon-dashboard-icons-03"}
//                     activeRoute={activeRoute}
//                   ></SidebarNavLink>
//                 )}
// {/* 
//                 {role == "sales" && evaluateAccessibility(
//                   "/admin/accounts/sales",
//                   <SidebarNavLink
//                     menuName={"Contacts"}
//                     menuURL={"/admin/accounts"}
//                     menuItems={salesAccountMenu}
//                     menuIcon={"now-ui-icons icon-dashboard-icons-03"}
//                     activeRoute={activeRoute}
//                   ></SidebarNavLink>
//                 )} */}
//                 {/* {evaluateAccessibility(
//                   "/audience",
//                   <SidebarNavLink
//                     menuName={"Audience"}
//                     menuURL={"/admin/audience"}
//                     menuItems={audienceMenuItems}
//                     menuIcon={"now-ui-icons icon-dashboard-icons-02"}
//                     activeRoute={activeRoute}
//                   ></SidebarNavLink>
//                 )} */}
//                 {evaluateAccessibility(
//                   "/sales",
//                   <SidebarNavLink
//                     menuName={"Sales"}
//                     menuURL={"/admin/sale"}
//                     menuItems={salesMenuItems}
//                     menuIcon={"fas fa-compass"}
//                     activeRoute={activeRoute}
//                   ></SidebarNavLink>
//                 )}
//                 {evaluateAccessibility(
//                   "/campaign",
//                   <SidebarNavLink
//                     menuName={"Campaign"}
//                     menuURL={"/admin/campaign"}
//                     menuItems={campaignMenuItems}
//                     menuIcon={"now-ui-icons icon-campaign"}
//                     activeRoute={activeRoute}
//                   ></SidebarNavLink>
//                 )}
//                 {evaluateAccessibility(
//                   "/templates",
//                   <SidebarNavLink
//                     menuName={"Content"}
//                     menuURL={"/admin/templates"}
//                     menuItems={templateMenuItems}
//                     menuIcon={"now-ui-icons icon-event-02"}
//                     activeRoute={activeRoute}
//                   ></SidebarNavLink>
//                 )}
//                 {evaluateAccessibility(
//                   "/workflow",
//                   <SidebarNavLink
//                     menuName={"Engagement Builder"}
//                     menuURL={"/admin/workflow"}
//                     menuItems={workflowMenuItems}
//                     menuIcon={"fas fa-tachometer-alt"}
//                     activeRoute={activeRoute}
//                   ></SidebarNavLink>
//                 )}
//                 {evaluateAccessibility(
//                   "/triggersAndEvents",
//                   <SidebarNavLink
//                     menuName={"Tags"}
//                     menuURL={"/admin/triggersAndEvents"}
//                     menuItems={eventsignalMenuItems}
//                     menuIcon={"fa fa-bolt"}
//                     activeRoute={activeRoute}
//                   ></SidebarNavLink>
//                 )}
//                 {evaluateAccessibility(
//                   "/settings",
//                   <SidebarNavLink
//                     menuName={"Settings"}
//                     menuURL={"/admin/settings"}
//                     menuItems={settings}
//                     menuIcon={"fa fa-cog"}
//                     activeRoute={activeRoute}
//                   ></SidebarNavLink>
//                 )}
//                 <li>
//                   <NavLink
//                     onClick={() => logoutHandler()}
//                     // tabIndex="-1"
//                     activeClassName="active"
//                     className="nav-link has_left_icon"
//                     to=""
//                     onMouseOver={() => {
//                       setLogoutHover(true);
//                     }}
//                     onMouseLeave={() => {
//                       setLogoutHover(false);
//                     }}
//                   >
//                     <span className="menu_icon">
//                       <span className="svg_outer">
//                         {logout_hover ? (
//                           <span
//                             className="now-ui-icons icon-switch"
//                             style={{
//                               color: "#2C40CE",
//                               transition: "0.3s ease-in-out",
//                             }}
//                           ></span>
//                         ) : (
//                           <span className="now-ui-icons icon-switch"></span>
//                         )}
//                       </span>
//                     </span>
//                     Logout:
//                     <p id="logout-email" style={{ textTransform: "lowercase" }}>
//                       <span style={{fontSize:'11px'}} >{user.userEmail}</span>
//                     </p>
//                   </NavLink>
//                 </li>
//               </ul>
//             </div>
//           </Nav>

//         </div>
//         <div className="sidebar-footer"
//           ref={sidebarfooter_ref}
//           onClick={(e) => { scrollToBottom(document.getElementsByClassName('Sidebar')[0]) }}
//         >
//           <i class="fa fa-angle-double-down" aria-hidden="true"></i>

//         </div>
//       </div>
//     </div>
  );
}
